import { render, staticRenderFns } from "./CloudClass.vue?vue&type=template&id=2bf021d9&"
import script from "./CloudClass.vue?vue&type=script&lang=js&"
export * from "./CloudClass.vue?vue&type=script&lang=js&"
import style0 from "./CloudClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports